<template>
	<line-banner-register type="event" />
</template>

<script>
	import LineBannerRegister from '@/components/LineBannerRegister.vue';

	export default {
		components: {
			LineBannerRegister,
		},
	};
</script>

<style style="scss" scoped></style>
